const initGoogleAnalytics = () => {
  const deviceId = window.$amplitudeDeviceId
  if (!deviceId) {
    console.warn('initGoogleAnalytics deviceId processing...')
    setTimeout(initGoogleAnalytics, 1000)
  } else {
    console.warn('initGoogleAnalytics deviceId is set')
    window.dataLayer = window.dataLayer || []
    function gtag () { window.dataLayer.push(arguments) }

    gtag('js', new Date())

    setTimeout(() => {
      gtag('config', 'G-TDTST7GX0W', {
        user_id: deviceId
      })
    }, 50)
  }
}

initGoogleAnalytics()
